import { useCallback } from 'react';

import logger from '@/utils/logger';

import { AUTH_CANCELLED_MESSAGE } from './OtpStrategyProvider';
import { useAuthStrategy } from './useAuthStrategy';

// gloss
export const usePassAuthGate = () => {
  const { handleAuth } = useAuthStrategy();

  return useCallback(
    async (options?: { email?: string }): Promise<boolean> => {
      try {
        await handleAuth(options);
        return true;
      } catch (error) {
        if ((error as Error | undefined)?.message !== AUTH_CANCELLED_MESSAGE) {
          logger.error(error, { context: 'authGate' });
        }
        return false;
      }
    },
    [handleAuth],
  );
};
